// extracted by mini-css-extract-plugin
export default {"layoutedContentGrid":"fsp-layoutedContentGrid","gridContent":"fsp-gridContent"};